import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { ItemType } from '../../models/item-type';
import { Router, ActivatedRoute } from '@angular/router';
import { ItemTypeService } from '../../services/item-type.service';
import { EditForm } from '../../../../base/controlers/edit-form';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-item-type-edit',
  templateUrl: './item-type-edit.component.html',
  styleUrls: ['./item-type-edit.component.css']
})
export class ItemTypeEditComponent extends EditForm<ItemType> {
  constructor(
    ns: ToastrService,          
    tr: TranslateService,
    r: Router,
    ds:ItemTypeService,
    ar: ActivatedRoute,
    l:Location,    
  ) {     
    super(ns,tr,r,ds,ar,l,'/timeTracking/types');
  }

  ngOnInit() {
    this.form = new FormGroup({
      id: new FormControl(),
      code: new FormControl(),
      name: new FormControl(),
      order: new FormControl(0),
      color: new FormControl(),
      active: new FormControl(true)
    })    
    super.ngOnInit();
  }
}
